<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="12">
            <h3>Dashboard</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body> </b-card-body>
      <b-row>
        <b-col sm="3">
          <b-container fluid>
            <b-card header-tag="header" body-class="text-center" id="tooltip-1">
              <b-tooltip target="tooltip-1"
                >Quantidade de Voluntárias registradas pelos Gestores e Tutores dos municípios na funcionalidade de relatório.</b-tooltip
              >
              <template #header>
                <h6 class="mb-0"><b>Quantidade de Voluntárias</b></h6>
              </template>
              <h1>{{ voluntarias }}</h1>
              <b-card-text></b-card-text>
            </b-card>
          </b-container>
        </b-col>
        <b-col sm="3">
          <b-container fluid>
            <b-card header-tag="header" body-class="text-center" id="tooltip-2">
              <b-tooltip target="tooltip-2"
                >Quantidade de Beneficiárias registradas pelos Gestores e Tutores dos municípios na funcionalidade de relatório.</b-tooltip
              >
              <template #header>
                <h6 class="mb-0"><b>Quantidade de Beneficiárias</b></h6>
              </template>
              <h1>{{ beneficiarias }}</h1>
              <b-card-text></b-card-text>
            </b-card>
          </b-container>
        </b-col>
        <b-col sm="3">
          <b-container fluid>
            <b-card header-tag="header" body-class="text-center" id="tooltip-4">
              <b-tooltip target="tooltip-4"
                >Quantidade de atendimentos realizados registrados pelos Gestores e Tutores dos municípios na funcionalidade de relatório.</b-tooltip
              >
              <template #header>
                <h6 class="mb-0">
                  <b>Quantidade de Atendimentos Realizados</b>
                </h6>
              </template>
              <h1>{{ qtdAtendimentosRealizados }}</h1>
              <b-card-text></b-card-text>
            </b-card>
          </b-container>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <b-card header-tag="header" body-class="text-center" id="tooltip-7">
              <b-tooltip target="tooltip-7"
                >Quantidade de Voluntárias e Beneficiárias registradas pelos Gestores e Tutores dos municípios na funcionalidade de relatório, ordenado por Município/Estado.</b-tooltip
              >
              <template #header>
                <h6 class="mb-0">
                  <b>Voluntárias e Beneficiárias por Município</b>
                </h6>
              </template>
              <b-card-text>
                <GraficoBar
                  v-if="is_ready_voluntarias_beneficiarias"
                  :dados="dados_voluntarias_beneficiarias"
                  :labels="labels_grafico_municipio"
                  :options="options"
                />
              </b-card-text>
            </b-card>
          </b-container>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <b-container fluid>
            <b-card header-tag="header" body-class="text-center" id="tooltip-8">
              <b-tooltip target="tooltip-8"
                >Quantidade de Municípios cadastrados e ativos na funcionalidade 'Gerenciar Municípios'.</b-tooltip
              >
              <template #header>
                <h6 class="mb-0">
                  <b>Quantidade de Municípios atendidos pelo projeto</b>
                </h6>
              </template>
              <h1>{{ qtdMunicipiosAtendidosProjeto }}</h1>
              <b-card-text></b-card-text>
            </b-card>
          </b-container>
        </b-col>
        <b-col sm="3">
          <b-container fluid>
            <b-card header-tag="header" body-class="text-center" id="tooltip-9">
              <b-tooltip target="tooltip-9"
                >Quantidade de Estados que tenham municípios cadastrados e ativos na funcionalidade 'Gerenciar Municípios'.</b-tooltip
              >
              <template #header>
                <h6 class="mb-0">
                  <b>Quantidade de Estados atendidos pelo projeto</b>
                </h6>
              </template>
              <h1>{{ qtdEstadosAtendidosProjeto }}</h1>
              <b-card-text></b-card-text>
            </b-card>
          </b-container>
        </b-col>
        <b-col sm="3">
          <b-container fluid>
            <b-card
              header-tag="header"
              body-class="text-center"
              id="tooltip-11"
            >
              <b-tooltip target="tooltip-11"
                >Quantidade de Gestores e Tutores cadastrados no sistema na
                situação "Ativo".</b-tooltip
              >
              <template #header>
                <h6 class="mb-0">
                  <b>Quantidade de Agentes Públicos envolvidos</b>
                </h6>
              </template>
              <h1>{{ qtdAgentesPublicosEnvolvidos }}</h1>
              <b-card-text></b-card-text>
            </b-card>
          </b-container>
        </b-col>
      </b-row>
      <b-card-footer> </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/PaginationRelatorio'
import GraficoDoughnut from '@/components/GraficoDoughnut'
import GraficoBar from '@/components/GraficoBar'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  components: {
    Pagination,
    GraficoDoughnut,
    GraficoBar
  },
  created () {
    this.$store.dispatch('getDadosDashboard')
  },
  data () {
    return {
      is_ready_beneficiarias: false,
      is_ready_voluntarias: false,
      is_ready_voluntarias_beneficiarias: false,
      options: {
        legend: { position: 'top', display: true },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      options_doughnut: {
        legend: {
          position: 'bottom'
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex]
              var meta = dataset._meta[Object.keys(dataset._meta)[0]]
              var total = meta.total
              var currentValue = dataset.data[tooltipItem.index]
              var percentage = parseFloat(
                ((currentValue / total) * 100).toFixed(1)
              )
              return currentValue + ' (' + percentage + '%)'
            },
            title: function (tooltipItem, data) {
              return data.labels[tooltipItem[0].index]
            }
          }
        }
      },
      beneficiarias: 0,
      voluntarias: 0,
      labels_grafico_municipio: [],
      label_beneficiarias: {
        label: 'Beneficiárias',
        data: [],
        borderColor: '#fd7e14',
        backgroundColor: '#fd7e14'
      },
      label_voluntarias: {
        label: 'Voluntárias',
        data: [],
        borderColor: '#083a6f',
        backgroundColor: '#083a6f'
      },
      dados_voluntarias_beneficiarias: [],
      qtdAtendimentosAgendados: 0,
      qtdAtendimentosRealizados: 0,
      qtdMunicipiosAtendidosProjeto: 0,
      qtdEstadosAtendidosProjeto: 0,
      qtdBeneficiariasVinculadas: 0,
      qtdAgentesPublicosEnvolvidos: 0
    }
  },
  computed: {
    dados () {
      return this.$store.state.usuario.dadosDashboard
    }
  },
  watch: {
    dados: function () {
      this.beneficiarias = this.dados.beneficiarias
      this.voluntarias = this.dados.voluntarias
      this.qtdAtendimentosAgendados = this.dados.qtdAtendimentosAgendados
      this.qtdAtendimentosRealizados = this.dados.qtdAtendimentosRealizados
      this.qtdMunicipiosAtendidosProjeto =
        this.dados.qtdMunicipiosAtendidosProjeto
      this.qtdEstadosAtendidosProjeto = this.dados.qtdEstadosAtendidosProjeto
      this.qtdBeneficiariasVinculadas = this.dados.qtdBeneficiariasVinculadas
      this.qtdAgentesPublicosEnvolvidos =
        this.dados.qtdAgentesPublicosEnvolvidos
      let voluntarias_beneficiarias_grafico =
        this.dados.voluntarias_beneficiarias_por_municipio

      this.is_ready_beneficiarias = true
      this.is_ready_voluntarias = true

      // Voluntárias e Beneficiárias por municipio
      for (let index in voluntarias_beneficiarias_grafico) {
        this.labels_grafico_municipio.push(voluntarias_beneficiarias_grafico[index].cidade + ' - ' + voluntarias_beneficiarias_grafico[index].sigla)
        this.label_beneficiarias.data.push(
          voluntarias_beneficiarias_grafico[index].beneficiarias
        )
        this.label_voluntarias.data.push(
          voluntarias_beneficiarias_grafico[index].voluntarias
        )
      }
      this.dados_voluntarias_beneficiarias.push(this.label_beneficiarias)
      this.dados_voluntarias_beneficiarias.push(this.label_voluntarias)
      this.is_ready_voluntarias_beneficiarias = true
    }
  },
  mounted () {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/relatorios/Dashboard.vue